<section class="title-bar content-padding first-item ">
  <div class="wrapper nowrap">
    <h2 class="title-heading">{{adminSmsTemplate?.id ? "Modifica" : "Nuovo"}} Modello SMS</h2>
    <div class="item nowrap">
      <span class="data-row-left btn-container top-button-container">
      </span>
    </div>
  </div>
</section>

<section class="content-padding darker">
    <div class="narrow-wrapper">
        <form class="has-cols" [formGroup]="_smsTemplateForm" (ngSubmit)="onSubmit()">
            <div class="col-48 grid-element">
                <label for="temp_type">Tipo{{ _smsTemplateForm.get("temp_type") | required }}</label>
                <select type="text" formControlName="temp_type">
                    <option></option>
                    <option value="Created">Created</option>
                    <option value="Started">Started</option>
                    <option value="Arrived">Arrived</option>
                </select>
                <app-error-html-handler [ctrl]="_smsTemplateForm.get('temp_type')" [messages]="formValidationMsgs.temp_type">
                </app-error-html-handler>
            </div>

            <br class="clear" *ngIf="!adminSmsTemplate?.id">

            <div class="col-48 grid-element" *ngIf="!adminSmsTemplate?.id">
              <!-- <label for="deluxyDelivery"></label> -->
              <label class="original-label">
                <input type="checkbox" name="deluxyDelivery" (click)="handleClickForDeluxy($event)">
                Modello di SMS per l'amministratore
              </label>
            </div> 

            <br class="clear" *ngIf="!adminSmsTemplate?.id"> 

            <div class="col-48 grid-element" formGroupName="partner" *ngIf="!adminSmsTemplate?.id && !smsTempForAdmin">
              <label>Partner{{ _smsTemplateForm.get('partner').get('id') | required }}</label>
              <select id="selezionePartner" type="text" formControlName="id">
                <option disabled></option>
                <option *ngFor="let partner of partners" [value]="partner.id"
                  [selected]="adminSmsTemplate && adminSmsTemplate.partner && adminSmsTemplate.partner.id == partner.id">{{partner.businessName}}
                </option>
              </select>
              <app-error-html-handler [ctrl]="_smsTemplateForm.get('partner').get('id')"
                [messages]="formValidationMsgs.partner.id">
              </app-error-html-handler>
            </div>
            
            <br class="clear" *ngIf="!adminSmsTemplate?.id"> 

            <div class="col-48 grid-element" *ngIf="adminSmsTemplate?.id && adminSmsTemplate?.partner" readonly="true">
              <label>Partner</label>
              <div *ngFor="let partner of partners">
                <input type="text" readonly="true" [value]="partner.businessName" *ngIf="adminSmsTemplate && adminSmsTemplate.partner && adminSmsTemplate.partner.id == partner.id">
              </div>
            </div>


            <div class="col-100 grid-element">
                <label for="description">Descrizione{{ _smsTemplateForm.get("description") | required }}</label>
                <textarea rows="5" placeholder="Scrivi una descrizione" formControlName="description"></textarea>
                <app-error-html-handler [ctrl]="_smsTemplateForm.get('description')" [messages]="formValidationMsgs.description">
                </app-error-html-handler>
            </div>
            <br class="clear">
            <div class="center">
                <button class="btn hvr-shrink center" [disabled]="!_smsTemplateForm?.valid || tmpBtnDisabled" (click)="$event.preventDefault(); onSubmit()">
                  Salva<i class="ml-10 far fa-save"></i>
                </button>
            </div>
        </form>
    </div>
</section>
